<template>
  <div>
    <hr />
    <h6>{{ $t("SEND_NEWS.Change_Subject_ViewType_Title") }}</h6>
    <b-form-radio-group
      v-model="subjectViewType"
      :options="options"
      class="demo-inline-spacing mb-1"
      value-field="value"
      text-field="text"
      disabled-field="disabled"
    />
  </div>
</template>

<script>
import { BFormRadioGroup } from "bootstrap-vue";
import AppConstants from "@/appConstants";
export default {
  components: {
    BFormRadioGroup,
  },
  data() {
    return {
      options: [
        { text: this.$t("SEND_NEWS.Subject_View_Type_List"), value: AppConstants.SUBJECT_VIEWTYPE_LIST },
        { text: this.$t("SEND_NEWS.Subject_View_Type_Checkbox"), value: AppConstants.SUBJECT_VIEWTYPE_CHECKBOX },
      ],
    };
  },
  computed: {
    subjectViewType: {
      get() {
        return (
          this.$store.state.auth.currentUser.subjectViewType || AppConstants.SUBJECT_VIEWTYPE_LIST
        );
      },
      set(val) {
        this.$store.dispatch("auth/updateSubjectViewType", val);
      },
    },
  },
  methods: {},
};
</script>

<style>
</style>